export default __webpack_public_path__ + "static/media/ismart.6137d3a9.png";